import { render, staticRenderFns } from "./Deductions.vue?vue&type=template&id=62233e23&scoped=true&"
import script from "./Deductions.vue?vue&type=script&lang=js&"
export * from "./Deductions.vue?vue&type=script&lang=js&"
import style0 from "./Deductions.vue?vue&type=style&index=0&id=62233e23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62233e23",
  null
  
)

export default component.exports